import React from "react";

import burhanTeam from "../../assets/img/burhan-team.jpg";

export default function BhStory(){
    return(
        <>

<section id="about" className="about">
          <h2 className="section-header mb1 nodash">
            Make your landscaping project a true success
          </h2>
          <hr />
          <div className="row writtenContent">
            <div
              className="col-lg-6 order-1 order-lg-2 px-5 "
              data-aos="fade-left"
            >
              <img loading="lazy" src={burhanTeam} alt="" className="img-fluid aboutImg" />
            </div>
            <div
              className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content"
              data-aos="fade-right"
            >
              <div className="corner-left">
                <div className="title" data-aos="zoom-in">
                  <h3>BUR-HAN GARDEN & LAWN CARE</h3>
                </div>
                <div
                  className="aboutSentence "
                  data-aos="fade-right"
                  data-duration="2000"
                >
                  <p>
                    {" "}
                    BUR-HAN Garden & Lawn Care has been providing Residential &
                    Commercial landscaping services for over 30 years. It is our
                    goal to provide our clients with the best possible
                    landscaping in Vancouver. We are passionate about creating
                    outdoor environments that inspire and captivate. With our
                    unwavering commitment to excellence, we go above and beyond
                    to exceed our partners' expectations. From the initial
                    consultation to the final touches, our experienced team
                    works closely with you, ensuring that every detail aligns
                    with your vision and preferences. With our comprehensive
                    range of services, including landscape design, installation,
                    and maintenance, we have the expertise to handle projects of
                    any size and complexity. Whether you envision a lush garden
                    retreat, a captivating hard scape, or a sustainable
                    landscape design, our dedicated professionals are here to
                    bring your dreams to life.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        </>
)}